const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2245"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 74",
    style: {
      fill: "#ebebeb",
      stroke: "#ccc"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2246",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5289",
    d: "M16 15A11 11 0 0 0 5 26v2a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-2a11 11 0 0 0-11-11z",
    style: {
      fill: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 75",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(10 1)",
    style: {
      fill: "#d3d3d3"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/userAvatar.2f43c7a328700e2ff5a9c55373217ff2.svg";
export { ForwardRef as ReactComponent };